<template>
  <div class="home">
    <va-page-header>

      <div v-if="surveys !== null" slot="title">
        <span>Afghan Parliamentary Election 2018</span>
      </div>

      <div v-if="surveys !== null" slot="actions">
        <!-- <va-button style="position: absolute; right: 22px; top: 70px;" type="primary" @click.native="navigate('/survey')">New Survey</va-button> -->
        <va-button @click.native="navigate('/survey')" style="position: absolute; right: 22px; top: 70px;" type="primary" size="lg">NEW SURVEY</va-button>
      </div>

    </va-page-header>
    <va-table v-if="surveys !== null" :hover="true" :full-width="true" class="datatable">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Province</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="survey in surveys" style="height:38px">
            <td>
              <!-- {{survey.name}} -->
              <!-- <va-button type="link" @click.native="navigate('/survey/' + survey.id)">{{ survey.name }}</va-button> -->
              <a style="cursor:pointer" @click="navigate('/survey/' + survey.id)">{{survey.name}}</a>
            </td>
            <td>{{ survey.province }}</td>
            <td>
              <va-lozenge v-if="survey.status == 'completed'" type="success" bold>{{ survey.status }}</va-lozenge>
              <va-lozenge v-else-if="survey.status == 'running'" type="primary" bold>{{ survey.status }}</va-lozenge>
              <va-lozenge v-else type="warning" bold>{{ survey.status }}</va-lozenge>
            </td>
            <td>
              <va-dropdown>
                <div slot="trigger">
                  <va-icon type="ellipsis-h" margin="0 0 0 7px"></va-icon>
                </div>
                <li>
                  <a href="#" v-if="survey.status == 'running'">Stop</a>
                </li>
                <li>
                  <a href="#" v-if="survey.status == 'running' || survey.status == 'completed' ">Results</a>
                </li>
                <li>
                  <a href="#" v-if="survey.status == 'new'">Publish</a>
                </li>
                <li>

                  <a @click="deleteSurvey(survey.id)">Delete</a>
                </li>
              </va-dropdown>
            </td>

          </tr>
        </tbody>
      </table>
    </va-table>

    <loader v-else-if="loading" />

    <div v-else :class="$style.deadCenter">
      <p>No surveys available</p>
      <br>
      <va-button type="primary" @click.native="navigate('/survey')">New Survey</va-button>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import loader from "@/components/Loader";
  export default {
    name: "home",
    data() {
      return {
        loading: true,
        surveys: null,
      };
    },
    components: {
      loader
    },
    computed: {
      // ...mapGetters(["getSurveys"])
    },
    methods: {
      // ...mapActions(["fetchSurveys"]),
      navigate(to) {
        this.$router.push(to);
      },
      deleteSurvey(id) {
        this.VaModal.alert({
          title: 'Are you sure!',
          message: 'Please make sure if you want to delete this survey. All results related to this survey will also be deleted.',
          type: "danger",
          width: 500,
          onConfirm() {
            db.collection("surveys").doc(id).delete();
          }
        })
      }
    },
    mounted() {
      var surveys = [];
      var surveysRef = db.collection("surveys");
      if (surveysRef !== null) {
        surveysRef.onSnapshot(querySnapshot => {
          surveys = [];
          querySnapshot.forEach(doc => {
            surveys.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // this.$store.commit("updateSurveys", surveys);
          this.surveys = surveys;
          this.loading = false;
          // setTimeout(() => this.loading = false, 2000);
        });
      }
    }
  };
</script>

<style module>
  .va-page-header-breadcrumb-wrapper {
    display: none;
  }

  .deadCenter {
    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
  }

  .horCenter {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
  }

  .loader {
    margin: auto;
    text-align: center;
  }

  .homeContent {
    text-align: center;
  }
</style>